export default __webpack_public_path__ + "static/media/alm_acompanha.33c2e229.png";